<template>
  <GenericModal
    v-model="isOpen">
    <div class="c-modal__header">
      <div class="c-modal__title">
        {{ title }}
      </div>
      <button
        class="c-modal__close"
        @click="isOpen = false">
        <SvgIcon
          type="close"
          small />
      </button>
    </div>
    <div class="c-modal__content">
      <div
        class="t-body3"
        v-html="content" />
      <label
        v-if="requiredConfirmationText"
        class="c-confirmationModal__typedConfirmation">
        <span class="t-caption1">{{ typedConfirmationLabel }}</span>
        <input
          v-model="typedConfirmationInput"
          class="c-input"
          type="text"
          autocomplete="off" />
      </label>
    </div>
    <div class="c-modal__actions o-flex -spaceBetween">
      <button
        class="c-button -compact -primary"
        :class="confirmButtonClass"
        :disabled="isConfirmDisabled"
        @click="confirm">
        {{ confirmButtonText }}
      </button>
      <button
        class="c-button -compact"
        @click="isOpen = false">
        {{ $t('generic.abort') }}
      </button>
    </div>
  </GenericModal>
</template>

<script>

export default {
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    confirmButtonClass: {
      type: String,
      required: false,
      default: '',
    },
    requiredConfirmationText: {
      type: String,
      required: false,
      default: '',
    },
    typedConfirmationLabel: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      typedConfirmationInput: '',
    }
  },
  computed: {
    isOpen: {
      set(isOpen) {
        this.$emit('input', isOpen)
      },
      get() {
        return this.value
      },
    },
    isConfirmDisabled() {
      return this.requiredConfirmationText !== ''
        && this.typedConfirmationInput !== this.requiredConfirmationText
    },
  },
  watch: {
    isOpen(isOpen) {
      if (!isOpen) {
        this.typedConfirmationInput = ''
      }
    },
  },
  methods: {
    confirm() {
      if (this.isConfirmDisabled) {
        return
      }
      this.isOpen = false
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/config';

.c-confirmationModal__typedConfirmation {
  display: flex;
  flex-direction: column;
  gap: $spacing-1;
  margin-top: $spacing-4;
}
</style>
